import React, {useState} from "react"

import "../../page/Shop/Shop.css"

import ShopProgress from "./ShopProgress"
import {numberWithCommas, validatePhone} from "../../common";


const OrderProduct = ({orderProduct, index, onChange, onDelete}) => {
	const [tempQuantity, setTempQuantity] = useState(orderProduct?.quantity)
	const [quantity, setQuantity] = useState(orderProduct?.quantity)

	return (
		<tr>
			<td>
				<div className="itemName">
					<span>【{orderProduct?.product?.group}】 {orderProduct?.product?.name}</span>
					{orderProduct?.product?.desc}
				</div>
			</td>
			<td className="itemPrice">{orderProduct?.product?.price}원</td>
			<td>
				<span className="itemQty">
					<input type="text"  maxLength={8} name="qty" placeholder="0" required value={tempQuantity} onChange={e => {
						// if (!validatePhone(e.target.value, setTempQuantity)) return
						setTempQuantity(e.target.value.replace(/[^\d]/,''))
					}} />
					<button type="button" onClick={() => {
						setQuantity(tempQuantity)
						onChange(index, tempQuantity)
					}}>변경</button>
				</span>
			</td>
			<td className="orderPrice">{numberWithCommas(orderProduct?.product?.price * quantity)}원</td>
			<td className="itemTax">{!orderProduct?.product?.vat ? '면세' : numberWithCommas(orderProduct?.product.vat)}</td>
			<td className="itemCart">
				<button type="button" onClick={() => onDelete(index)}>삭제</button>
			</td>
		</tr>
	)
}

function ItemCheck({orderProducts: prevOrderProducts, setOrderProducts: setRootOrderProducts, setStep}) {

	const [orderProducts, setOrderProducts] = useState(prevOrderProducts)

	const onChange = (index, quantity) => {
		orderProducts[index].quantity = quantity
		setOrderProducts(Object.assign([], orderProducts))
	}

	const onDelete = (index) => {
		orderProducts.splice(index, 1)
		setOrderProducts(Object.assign([], orderProducts))
	}

	const noVatPrice = orderProducts.filter(item => !item?.product?.vat).map(item => item?.product?.price * item?.quantity).reduce((prev, curr) => prev + curr, 0)
	const onVatPrice = orderProducts.filter(item => !!item?.product?.vat).map(item => item?.product?.price * item?.quantity).reduce((prev, curr) => prev + curr, 0)
	const vatPrice = orderProducts.filter(item => !!item?.product?.vat).map(item => item?.product?.vat * item?.quantity).reduce((prev, curr) => prev + curr, 0)
	const totalPrice = noVatPrice + onVatPrice + vatPrice

	return (
		<>
			<div className="cardContent itemCheck">
				<form name="itemCheck">
					<ShopProgress isSecond={true} />
					<div className="shopTableWrap">
						<table className="shopTable">
							<colgroup>
								<col width="40%" />
								<col width="15%" />
								<col width="10%" />
								<col width="15%" />
								<col width="10%" />
								<col width="10%" />
							</colgroup>
							<thead>
								<tr>
									<th>상품명</th>
									<th>금액</th>
									<th>수량</th>
									<th>주문금액</th>
									<th>부가세</th>
									<th></th>
								</tr>
							</thead>
							<tbody>
								{orderProducts?.map((item, index) => {
									return (
										<OrderProduct orderProduct={item} index={index} onChange={onChange} onDelete={onDelete}/>
									)
								})}
								<tr>
									<td colSpan={6} className="totalPrice">
										면세금액 <b>{numberWithCommas(noVatPrice)}원</b> + 과세금액 <b>{numberWithCommas(onVatPrice)}원</b> + 부가가치세 <b>{numberWithCommas(vatPrice)}원</b> = 총 상품가격 <b>{numberWithCommas(totalPrice)}원</b>
									</td>
								</tr>
								<tr>
									<td colSpan={6} className="totalOrder">
										<div>
											결제 예정 금액
											<span>
												총 주문금액 <b>{numberWithCommas(totalPrice)}원</b>
											</span>
										</div>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div className="shopBtnWrap">
						<button type="button" onClick={() => window.open('http://pf.kakao.com/_eRLrj/chat')}>기타 견적서 요청</button>
						<button type="submit" onClick={() => {
							setRootOrderProducts(orderProducts)
							setStep(2)
						}}>주문 결제</button>
					</div>
				</form>
			</div>
		</>
	)
}

export default ItemCheck
